import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'aboca-apoteca-desktop-fake-container',
  templateUrl: './apoteca-desktop-fake-container.component.html',
  styleUrls: ['./apoteca-desktop-fake-container.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ApotecaDesktopFakeContainerComponent {}
